"use client";

// 2026-08-29 minimalista pro — websearch 2026 Geist + Ethora 2026-06-02 — Recursos hover card no nav plano, ≤6 visibles (360/768/desktop)
// 2026-09-15 FASE 2 FIX 6 (isla interactiva — "use client" SE MANTIENE, no se
// migra a server: mobileOpen/scrolled/resourcesOpen son useState + 5 useEffect
// de scroll/resize/Escape/focus — migrarlo rompería el menú móvil y el hover
// card; RSC leaves-only = cliente solo en esta hoja, paridad Features/Footer).
// 2026-08-23 performance budget — LCP <2.5s, INP <200ms, CLS <0.1, 42% pass only;
// 2026-08-23 Header — Resources hover card, MINIMALISTA, 6 controls max, 360px verified;
// 2026-09-05 polish: gear opaco sin blur, transition-[transform,border-color] sin hover:shadow — solo clases.
import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState, type ComponentType, type ReactNode } from "react";
import { createPortal } from "react-dom";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { BookOpen, ChevronDown, Code2, FileText, Globe, History, LayoutDashboard, Menu, Palette, ScanSearch, Settings2, Tags, X, type LucideProps } from "lucide-react";
import { UserMenu } from "@/components/auth/UserMenu";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/ui/logo";
import { ResourcesMenu } from "@/components/landing/NavMenus";
import { LanguageSelector } from "@/components/i18n/LanguageSelector";
import { ThemeSelector } from "@/components/theme/ThemeSelector";
import { Dropdown, DropdownContent, DropdownTrigger } from "@/components/ui/dropdown";
import { useAuth } from "@/lib/auth-context";
import { localePath, stripLocalePrefix } from "@/lib/i18n/locales";
import { useLocale, useT } from "@/lib/use-i18n";
import { cn } from "@/lib/utils";
type NavIcon = ComponentType<LucideProps>;
function MobileNavLink(t0) {
  const $ = _c(27);
  const {
    href,
    pathname,
    onNavigate,
    children,
    icon: Icon,
    tone: t1
  } = t0;
  const tone = t1 === undefined ? "primary" : t1;
  let t2;
  if ($[0] !== href || $[1] !== pathname) {
    const cleanPath = stripLocalePrefix(pathname);
    let t3;
    if ($[3] !== href) {
      t3 = stripLocalePrefix(href);
      $[3] = href;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const cleanHref = t3;
    t2 = cleanPath === cleanHref || cleanPath.startsWith(`${cleanHref}/`);
    $[0] = href;
    $[1] = pathname;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const active = t2;
  const t3 = active ? "page" : undefined;
  const t4 = tone === "primary" ? "text-[var(--step-0)] font-medium" : "text-base font-semibold";
  const t5 = active ? "bg-[color-mix(in_srgb,var(--accent)_12%,transparent)] text-foreground" : "text-foreground-soft hover:bg-[var(--muted)] hover:text-foreground";
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = cn("group mobile-nav-link flex min-h-12 items-center gap-3 rounded-[var(--radius-button)] px-3 py-2.5 transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]", t4, t5);
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = active ? "bg-[var(--accent-soft)] text-foreground" : "bg-foreground/[0.04] text-muted-foreground group-hover:bg-foreground/[0.08] group-hover:text-foreground";
  let t8;
  if ($[8] !== t7) {
    t8 = cn("inline-flex size-9 shrink-0 items-center justify-center rounded-[var(--radius-sm)] transition-colors motion-reduce:transition-none", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== Icon) {
    t9 = <Icon className="size-4" aria-hidden="true" />;
    $[10] = Icon;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <span className={t8}>{t9}</span>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== children) {
    t11 = <span className="min-w-0 flex-1 text-left leading-snug">{children}</span>;
    $[15] = children;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== active) {
    t12 = active ? <span className="size-1.5 shrink-0 rounded-full bg-[var(--accent)]" aria-hidden="true" /> : null;
    $[17] = active;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== href || $[20] !== onNavigate || $[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t3 || $[25] !== t6) {
    t13 = <Link href={href} aria-current={t3} onClick={onNavigate} className={t6}>{t10}{t11}{t12}</Link>;
    $[19] = href;
    $[20] = onNavigate;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t3;
    $[25] = t6;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}
const NAV_LINK_CLASS = "hidden md:inline-flex items-center gap-1 rounded-[var(--radius-button)] px-3 py-1.5 text-sm font-medium text-foreground-soft transition-colors motion-reduce:transition-none hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]";
function SettingsDropdownContent() {
  const $ = _c(26);
  const t = useT();
  let t0;
  if ($[0] !== t) {
    t0 = t("chatSettings");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="px-3 pb-1.5 pt-2"><p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">{t0}</p></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="flex size-7 items-center justify-center rounded-lg bg-foreground/[0.04] text-muted-foreground transition-colors motion-reduce:transition-none group-hover/row:bg-foreground/[0.08] group-hover/row:text-foreground"><Palette className="size-3.5" strokeWidth={1.75} aria-hidden="true" /></span>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("chatTheme");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="flex items-center gap-2.5">{t2}<span className="text-[var(--step--1)] font-medium leading-none tracking-tight text-foreground">{t3}</span></span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ThemeSelector />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <div className="group/row flex items-center justify-between gap-3 rounded-[var(--radius-sm)] px-2.5 py-2 transition-colors motion-reduce:transition-none hover:bg-[var(--muted)]/70">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="flex size-7 items-center justify-center rounded-lg bg-foreground/[0.04] text-muted-foreground transition-colors motion-reduce:transition-none group-hover/row:bg-foreground/[0.08] group-hover/row:text-foreground"><Globe className="size-3.5" strokeWidth={1.75} aria-hidden="true" /></span>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("chatLanguage");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <span className="flex items-center gap-2.5">{t7}<span className="text-[var(--step--1)] font-medium leading-none tracking-tight text-foreground">{t8}</span></span>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <LanguageSelector />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t9) {
    t11 = <div className="group/row flex items-center justify-between gap-3 rounded-[var(--radius-sm)] px-2.5 py-2 transition-colors motion-reduce:transition-none hover:bg-[var(--muted)]/70">{t9}{t10}</div>;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t6) {
    t12 = <div className="flex flex-col gap-1">{t6}{t11}</div>;
    $[20] = t11;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t1 || $[24] !== t12) {
    t13 = <DropdownContent align="end" className="lovable-card lovable-card--static min-w-[232px] overflow-hidden p-1.5">{t1}{t12}</DropdownContent>;
    $[23] = t1;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
export function Header() {
  const $ = _c(103);
  const {
    user,
    loading
  } = useAuth();
  const t = useT();
  const locale = useLocale();
  const pathname = usePathname();
  let t0;
  if ($[0] !== locale) {
    t0 = path => localePath(locale, path);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const lp = t0;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [mobileMenuTop, setMobileMenuTop] = useState(72);
  const hamburgerRef = useRef(null);
  const headerBarRef = useRef(null);
  const menuRef = useRef(null);
  const wasMobileOpenRef = useRef(false);
  const scrollLockYRef = useRef(0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const bar = headerBarRef.current;
      if (!bar) {
        return;
      }
      const bottom = bar.getBoundingClientRect().bottom;
      setMobileMenuTop(Math.max(56, Math.round(bottom + 8)));
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const measureMobileMenuTop = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMobileOpen(false);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeMobile = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      measureMobileMenuTop();
      setMobileOpen(true);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const openMobile = t3;
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const onScroll = () => setScrolled(window.scrollY > 6);
      onScroll();
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", onScroll);
    };
    t5 = [];
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] !== mobileOpen) {
    t6 = () => {
      if (!mobileOpen) {
        return;
      }
      measureMobileMenuTop();
      const onResize = () => measureMobileMenuTop();
      window.addEventListener("resize", onResize);
      window.visualViewport?.addEventListener("resize", onResize);
      window.visualViewport?.addEventListener("scroll", onResize);
      return () => {
        window.removeEventListener("resize", onResize);
        window.visualViewport?.removeEventListener("resize", onResize);
        window.visualViewport?.removeEventListener("scroll", onResize);
      };
    };
    t7 = [mobileOpen];
    $[7] = mobileOpen;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[10] !== mobileOpen) {
    t8 = () => {
      if (mobileOpen) {
        wasMobileOpenRef.current = true;
        scrollLockYRef.current = window.scrollY;
        const y = scrollLockYRef.current;
        document.body.style.position = "fixed";
        document.body.style.top = `-${y}px`;
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
        document.body.style.overflow = "hidden";
        const firstFocusable = menuRef.current?.querySelector("a[href], button:not([disabled]), [tabindex]:not([tabindex=\"-1\"])");
        requestAnimationFrame(() => firstFocusable?.focus());
      } else {
        if (wasMobileOpenRef.current) {
          const y_0 = scrollLockYRef.current;
          document.body.style.position = "";
          document.body.style.top = "";
          document.body.style.left = "";
          document.body.style.right = "";
          document.body.style.width = "";
          document.body.style.overflow = "";
          window.scrollTo(0, y_0);
          hamburgerRef.current?.focus();
          wasMobileOpenRef.current = false;
        }
      }
      return () => {
        if (document.body.style.position === "fixed") {
          const y_1 = scrollLockYRef.current;
          document.body.style.position = "";
          document.body.style.top = "";
          document.body.style.left = "";
          document.body.style.right = "";
          document.body.style.width = "";
          document.body.style.overflow = "";
          window.scrollTo(0, y_1);
        }
      };
    };
    t9 = [mobileOpen];
    $[10] = mobileOpen;
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[13] !== mobileOpen) {
    t10 = () => {
      if (!mobileOpen) {
        return;
      }
      const handleKeyDown = e => {
        if (e.key === "Escape") {
          setMobileOpen(false);
          return;
        }
        if (e.key === "Tab") {
          const container = menuRef.current;
          if (!container) {
            return;
          }
          const focusable = container.querySelectorAll("a[href], button:not([disabled]), [tabindex]:not([tabindex=\"-1\"])");
          if (focusable.length < 2) {
            return;
          }
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else {
            if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t11 = [mobileOpen];
    $[13] = mobileOpen;
    $[14] = t10;
    $[15] = t11;
  } else {
    t10 = $[14];
    t11 = $[15];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[16] !== mobileOpen) {
    t12 = () => {
      if (!mobileOpen) {
        return;
      }
      const siblings = Array.from(document.body.children).filter(_temp) as HTMLElement[];
      for (const el_0 of siblings) {
        if (el_0.tagName === "SCRIPT" || el_0.tagName === "STYLE") {
          continue;
        }
        el_0.setAttribute("inert", "");
      }
      return () => {
        for (const el_1 of siblings) {
          el_1.removeAttribute("inert");
        }
      };
    };
    t13 = [mobileOpen];
    $[16] = mobileOpen;
    $[17] = t12;
    $[18] = t13;
  } else {
    t12 = $[17];
    t13 = $[18];
  }
  useEffect(t12, t13);
  const t14 = scrolled ? "rounded-full border border-[var(--border-strong)] bg-[color-mix(in_srgb,var(--background-elevated)_94%,transparent)] shadow-[var(--shadow-panel)] backdrop-blur-sm" : "rounded-full border border-transparent bg-[color-mix(in_srgb,var(--background)_72%,transparent)]";
  let t15;
  if ($[19] !== t14) {
    t15 = cn("relative z-[50] mx-auto flex h-14 max-w-container-wide items-center justify-between px-4 sm:px-6 transition-all duration-300 motion-reduce:transition-none", t14);
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== lp) {
    t16 = lp("/");
    $[21] = lp;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t) {
    t17 = t("brandHome");
    $[23] = t;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  let t19;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <LogoMark size={26} className="transition-transform duration-200 motion-reduce:transition-none motion-reduce:transform-none group-hover:scale-[1.03]" />;
    t19 = <span className="text-[var(--step--1)] font-medium tracking-tight lowercase text-foreground">vortixy</span>;
    $[25] = t18;
    $[26] = t19;
  } else {
    t18 = $[25];
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t16 || $[28] !== t17) {
    t20 = <Link href={t16} className="group flex items-center gap-2.5 rounded-lg transition-opacity motion-reduce:transition-none hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]" aria-label={t17}>{t18}{t19}</Link>;
    $[27] = t16;
    $[28] = t17;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t) {
    t21 = t("ariaMainNavigation");
    $[30] = t;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== loading || $[33] !== lp || $[34] !== resourcesOpen || $[35] !== t || $[36] !== user) {
    t22 = !loading && !user ? <><Link href={lp("/chat")} data-testid="header-control" className={NAV_LINK_CLASS}>{t("navChat")}</Link><Link href={lp("/pricing")} data-testid="header-control" className={NAV_LINK_CLASS}>{t("navPricing")}</Link><ResourcesMenu open={resourcesOpen} onOpenChange={setResourcesOpen} /><Link href={lp("/login")} data-testid="header-control" className={NAV_LINK_CLASS}>{t("navLogin")}</Link><Button variant="accent" size="sm" data-testid="header-control" className="hidden md:inline-flex" asChild={true}><Link href={lp("/signup")}>{t("navSignup")}</Link></Button></> : null;
    $[32] = loading;
    $[33] = lp;
    $[34] = resourcesOpen;
    $[35] = t;
    $[36] = user;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== loading || $[39] !== lp || $[40] !== resourcesOpen || $[41] !== t || $[42] !== user) {
    t23 = !loading && user ? <><Link href={lp("/chat")} data-testid="header-control" className={NAV_LINK_CLASS}>{t("navChat")}</Link><Link href={lp("/pricing")} data-testid="header-control" className={NAV_LINK_CLASS}>{t("navPricing")}</Link><ResourcesMenu open={resourcesOpen} onOpenChange={setResourcesOpen} /><span data-testid="header-control" className="hidden md:inline-flex"><UserMenu /></span></> : null;
    $[38] = loading;
    $[39] = lp;
    $[40] = resourcesOpen;
    $[41] = t;
    $[42] = user;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t) {
    t24 = t("chatSettings");
    $[44] = t;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Settings2 className="size-[15px] transition-transform duration-300 motion-reduce:transition-none motion-reduce:transform-none group-hover:rotate-90 group-data-[state=open]:rotate-90" strokeWidth={1.85} aria-hidden="true" />;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t24) {
    t26 = <DropdownTrigger className="group inline-flex size-8 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--card)] text-muted-foreground shadow-xs transition-[transform,border-color] duration-200 motion-reduce:transition-none hover:border-[var(--border-strong)] hover:bg-[var(--muted)] hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-background" aria-label={t24}>{t25}</DropdownTrigger>;
    $[47] = t24;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <SettingsDropdownContent />;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t26) {
    t28 = <div className="hidden md:flex items-center gap-1" data-testid="header-control"><Dropdown>{t26}{t27}</Dropdown></div>;
    $[50] = t26;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== lp) {
    t29 = lp("/chat");
    $[52] = lp;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t) {
    t30 = t("navChat");
    $[54] = t;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <ScanSearch className="size-[15px]" strokeWidth={1.85} aria-hidden="true" />;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== t29 || $[58] !== t30) {
    t32 = <Link href={t29} data-testid="header-control" aria-label={t30} className="inline-flex size-11 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--card)] text-muted-foreground shadow-xs transition-[transform,border-color] duration-200 motion-reduce:transition-none hover:border-[var(--border-strong)] hover:bg-[var(--muted)] hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-background md:hidden">{t31}</Link>;
    $[57] = t29;
    $[58] = t30;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t) {
    t33 = t("chatSettings");
    $[60] = t;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Settings2 className="size-[15px] transition-transform duration-300 motion-reduce:transition-none motion-reduce:transform-none group-hover:rotate-90 group-data-[state=open]:rotate-90" strokeWidth={1.85} aria-hidden="true" />;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== t33) {
    t35 = <DropdownTrigger className="group inline-flex size-11 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--card)] text-muted-foreground shadow-xs transition-[transform,border-color] duration-200 motion-reduce:transition-none hover:border-[var(--border-strong)] hover:bg-[var(--muted)] hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-background" aria-label={t33}>{t34}</DropdownTrigger>;
    $[63] = t33;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <SettingsDropdownContent />;
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== t35) {
    t37 = <div className="flex min-w-0 shrink-0 items-center gap-1 md:hidden" data-testid="header-control"><Dropdown>{t35}{t36}</Dropdown></div>;
    $[66] = t35;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] !== mobileOpen) {
    t38 = () => {
      if (mobileOpen) {
        closeMobile();
      } else {
        openMobile();
      }
    };
    $[68] = mobileOpen;
    $[69] = t38;
  } else {
    t38 = $[69];
  }
  let t39;
  if ($[70] !== mobileOpen || $[71] !== t) {
    t39 = mobileOpen ? t("navCloseMenu") : t("navOpenMenu");
    $[70] = mobileOpen;
    $[71] = t;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== mobileOpen) {
    t40 = mobileOpen ? <X className="size-4" aria-hidden="true" /> : <Menu className="size-4" aria-hidden="true" />;
    $[73] = mobileOpen;
    $[74] = t40;
  } else {
    t40 = $[74];
  }
  let t41;
  if ($[75] !== mobileOpen || $[76] !== t38 || $[77] !== t39 || $[78] !== t40) {
    t41 = <button ref={hamburgerRef} type="button" data-testid="header-control" onClick={t38} className="inline-flex size-11 items-center justify-center rounded-[var(--radius-button)] border border-transparent text-foreground transition-colors motion-reduce:transition-none hover:border-[var(--border)] hover:bg-[var(--muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] md:hidden" aria-label={t39} aria-expanded={mobileOpen} aria-controls="mobile-menu">{t40}</button>;
    $[75] = mobileOpen;
    $[76] = t38;
    $[77] = t39;
    $[78] = t40;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  let t42;
  if ($[80] !== t21 || $[81] !== t22 || $[82] !== t23 || $[83] !== t28 || $[84] !== t32 || $[85] !== t37 || $[86] !== t41) {
    t42 = <nav className="flex items-center gap-1 sm:gap-2" aria-label={t21}>{t22}{t23}{t28}{t32}{t37}{t41}</nav>;
    $[80] = t21;
    $[81] = t22;
    $[82] = t23;
    $[83] = t28;
    $[84] = t32;
    $[85] = t37;
    $[86] = t41;
    $[87] = t42;
  } else {
    t42 = $[87];
  }
  let t43;
  if ($[88] !== t15 || $[89] !== t20 || $[90] !== t42) {
    t43 = <div ref={headerBarRef} className={t15}>{t20}{t42}</div>;
    $[88] = t15;
    $[89] = t20;
    $[90] = t42;
    $[91] = t43;
  } else {
    t43 = $[91];
  }
  let t44;
  if ($[92] !== loading || $[93] !== lp || $[94] !== mobileMenuTop || $[95] !== mobileOpen || $[96] !== pathname || $[97] !== t || $[98] !== user) {
    t44 = mobileOpen && typeof document !== "undefined" ? createPortal(<div className="md:hidden" data-testid="mobile-nav-portal"><div tabIndex={-1} aria-hidden="true" onClick={closeMobile} className="mobile-nav-backdrop fixed inset-0 z-[60] border-0 p-0 opacity-100" /><div id="mobile-menu" ref={menuRef} role="dialog" aria-modal="true" aria-label={t("ariaMainNavigation")} data-testid="mobile-menu-sheet" className="mobile-nav-sheet fixed inset-x-0 z-[61] mx-auto w-full max-w-container-wide overflow-hidden px-3 pb-[env(safe-area-inset-bottom,0px)] opacity-100 translate-y-0 sm:px-4" style={{
        top: mobileMenuTop,
        maxHeight: `min(78dvh, calc(100dvh - ${mobileMenuTop + 12}px))`
      }}><div className="mobile-nav-panel mb-3 flex max-h-[inherit] flex-col overflow-hidden"><div className="flex items-center justify-between gap-3 border-b border-[var(--border)] px-4 py-3"><p className="text-[var(--step--1)] font-medium tracking-tight text-foreground">{t("navMenu")}</p><button type="button" onClick={closeMobile} className="inline-flex size-10 shrink-0 items-center justify-center rounded-[var(--radius-button)] border border-[var(--border)] bg-[var(--background-elevated)] text-muted-foreground transition-colors motion-reduce:transition-none hover:border-[var(--border-strong)] hover:bg-[var(--muted)] hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]" aria-label={t("navCloseMenu")}><X className="size-4" aria-hidden="true" /></button></div><div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-2 py-2"><nav className="flex flex-col gap-0.5" aria-label={t("ariaMainNavigationMobile")}><MobileNavLink href={lp("/chat")} pathname={pathname} onNavigate={closeMobile} icon={ScanSearch}>{t("navChat")}</MobileNavLink><MobileNavLink href={lp("/pricing")} pathname={pathname} onNavigate={closeMobile} icon={Tags}>{t("navPricing")}</MobileNavLink>{!loading && user ? <MobileNavLink href={lp("/dashboard")} pathname={pathname} onNavigate={closeMobile} icon={LayoutDashboard}>{t("navDashboard")}</MobileNavLink> : null}<div className="mx-2 my-2 h-px bg-[var(--border)]" role="separator" /><details data-testid="mobile-nav-resources" className="group/mnr"><summary className="flex min-h-12 cursor-pointer list-none items-center gap-3 rounded-[var(--radius-button)] px-3 py-2.5 text-[var(--step--1)] font-medium text-foreground-soft transition-colors motion-reduce:transition-none hover:bg-[var(--muted)] hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] [&::-webkit-details-marker]:hidden"><span className="inline-flex size-9 shrink-0 items-center justify-center rounded-[var(--radius-sm)] bg-foreground/[0.04] text-muted-foreground transition-colors motion-reduce:transition-none group-hover/mnr:bg-foreground/[0.08] group-hover/mnr:text-foreground"><BookOpen className="size-4" aria-hidden="true" /></span><span className="min-w-0 flex-1 text-left leading-snug">{t("navResources")}</span><ChevronDown className="size-4 shrink-0 transition-transform duration-200 motion-reduce:transition-none group-open/mnr:rotate-180" aria-hidden="true" /></summary><div className="flex flex-col gap-0.5 ps-3"><MobileNavLink href={lp("/blog")} pathname={pathname} onNavigate={closeMobile} icon={FileText} tone="secondary">{t("navBlog")}</MobileNavLink><MobileNavLink href={lp("/guides")} pathname={pathname} onNavigate={closeMobile} icon={BookOpen} tone="secondary">{t("navGuides")}</MobileNavLink><MobileNavLink href={lp("/docs")} pathname={pathname} onNavigate={closeMobile} icon={Code2} tone="secondary">{t("navDocs")}</MobileNavLink><MobileNavLink href={lp("/changelog")} pathname={pathname} onNavigate={closeMobile} icon={History} tone="secondary">{t("navChangelog")}</MobileNavLink></div></details></nav></div>{!loading && !user ? <div className="grid gap-2 border-t border-[var(--border)] bg-[var(--background-elevated)] px-3 py-3"><Button variant="accent" className="h-11 w-full justify-center text-[var(--step--1)]" onClick={closeMobile} asChild={true}><Link href={lp("/signup")}>{t("navSignup")}</Link></Button><Button variant="ghost" className="h-11 w-full justify-center text-[var(--step--1)] text-foreground-soft hover:text-foreground" onClick={closeMobile} asChild={true}><Link href={lp("/login")}>{t("navLogin")}</Link></Button></div> : null}{!loading && user ? <div className="border-t border-[var(--border)] bg-[var(--background-elevated)] px-3 py-3"><Button variant="accent" className="h-11 w-full justify-center text-[var(--step--1)]" onClick={closeMobile} asChild={true}><Link href={lp("/chat")}>{t("chatTitle")}</Link></Button></div> : null}</div></div></div>, document.body) : null;
    $[92] = loading;
    $[93] = lp;
    $[94] = mobileMenuTop;
    $[95] = mobileOpen;
    $[96] = pathname;
    $[97] = t;
    $[98] = user;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  let t45;
  if ($[100] !== t43 || $[101] !== t44) {
    t45 = <header className="sticky top-0 z-40 w-full px-4 py-2 sm:px-6">{t43}{t44}</header>;
    $[100] = t43;
    $[101] = t44;
    $[102] = t45;
  } else {
    t45 = $[102];
  }
  return t45;
}
function _temp(el) {
  return (el as HTMLElement).dataset?.testid !== "mobile-nav-portal" && !el.querySelector?.("[data-testid=\"mobile-nav-portal\"]");
}